// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CloudflareTurnstileController from "./cloudflare_turnstile_controller"
application.register("cloudflare-turnstile", CloudflareTurnstileController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterToggleController from "./filter_toggle_controller"
application.register("filter-toggle", FilterToggleController)

import MobileMenuFilterController from "./mobile_menu_filter_controller"
application.register("mobile-menu-filter", MobileMenuFilterController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import Tailwindui__DropdownController from "./tailwindui/dropdown_controller"
application.register("tailwindui--dropdown", Tailwindui__DropdownController)

import Tailwindui__MenuController from "./tailwindui/menu_controller"
application.register("tailwindui--menu", Tailwindui__MenuController)

import UpdateCartItemQuantityController from "./update_cart_item_quantity_controller"
application.register("update-cart-item-quantity", UpdateCartItemQuantityController)
